import { loyaltyActions } from './models/loyalty';

export const actions = {
  loyalty: loyaltyActions,
};
